<template>
  <a-popover
    v-model="showMemberChildren"
    placement="bottom"
    trigger="click"
    class="children-attach"
  >
    <div class="flex">
      <a-input
        class="coupon-plan-people-tpl-input w-16"
        size="large"
        :value="totalChildMemberCnt"
        @keypress="
          ($event) => {
            $event.preventDefault()
            return false
          }
        "
        style="background-color: #fff; color: inherit; cursor: pointer"
      />
    </div>
    <div slot="content" class="popover-custom-content">
      <div class="popover-block-first">
        <div class="block-first-title">小学生</div>
        <div class="block-first-content">
          <div class="set-value-group">
            <div class="set-value-name">高学年</div>
            <Stepper
              v-model="memberChildDetails.exUpperGradesHeadCnt"
              unit="人"
              :max="maxExUpperGradesHeadCnt"
              class="w-20"
            />
          </div>
          <div class="set-value-group">
            <div class="set-value-name">低学年</div>
            <Stepper
              v-model="memberChildDetails.exLowerGradesHeadCnt"
              unit="人"
              :max="maxExLowerGradesHeadCnt"
            />
          </div>
        </div>
      </div>
      <div class="popover-block-second">
        <div class="block-second-title">幼児</div>
        <div class="block-second-content">
          <div class="set-value-group">
            <div class="set-value-name">食事・布団付</div>
            <Stepper v-model="memberChildDetails.youjiAHeadCnt" unit="人" :max="maxYoujiAHeadCnt" />
          </div>
          <div class="set-value-group">
            <div class="set-value-name">食事のみ</div>
            <Stepper v-model="memberChildDetails.youjiBHeadCnt" unit="人" :max="maxYoujiBHeadCnt" />
          </div>
        </div>
      </div>
      <div class="popover-block-three">
        <div class="block-three-content">
          <div class="set-value-group">
            <div class="set-value-name">布団のみ</div>
            <Stepper v-model="memberChildDetails.youjiCHeadCnt" unit="人" :max="maxYoujiCHeadCnt" />
          </div>
          <div class="set-value-group">
            <div class="set-value-name">食事・布団不要</div>
            <Stepper v-model="memberChildDetails.youjiDHeadCnt" unit="人" :max="maxYoujiDHeadCnt" />
          </div>
        </div>
      </div>
    </div>
  </a-popover>
</template>

<script>
export default {
  data() {
    return {
      limitChildren: 10,
      showMemberChildren: false,
      memberChildDetails: {
        exUpperGradesHeadCnt: 0,
        exLowerGradesHeadCnt: 0,
        youjiAHeadCnt: 0,
        youjiBHeadCnt: 0,
        youjiCHeadCnt: 0,
        youjiDHeadCnt: 0
      },
      visitorChildDetails: {
        exUpperGradesHeadCnt: 0,
        exLowerGradesHeadCnt: 0,
        youjiAHeadCnt: 0,
        youjiBHeadCnt: 0,
        youjiCHeadCnt: 0,
        youjiDHeadCnt: 0
      }
    }
  },
  props: {
    filterForm: {
      default: () => ({})
    }
  },
  mounted() {
    Object.keys(this.memberChildDetails).forEach((key) => {
      this.memberChildDetails[key] = parseInt(this.filterForm[key]) || 0
    })
  },

  computed: {
    maxExUpperGradesHeadCnt() {
      return Math.min(this.limitChildren - this.totalMemberChildCnt + this.memberChildDetails.exUpperGradesHeadCnt, this.limitChildren)
    },
    maxExLowerGradesHeadCnt() {
      return Math.min(this.limitChildren - this.totalMemberChildCnt + this.memberChildDetails.exLowerGradesHeadCnt, this.limitChildren)
    },
    maxYoujiAHeadCnt() {
      return Math.min(this.limitChildren - this.totalMemberChildCnt + this.memberChildDetails.youjiAHeadCnt, this.limitChildren)
    },
    maxYoujiBHeadCnt() {
      return Math.min(this.limitChildren - this.totalMemberChildCnt + this.memberChildDetails.youjiBHeadCnt, this.limitChildren)
    },
    maxYoujiCHeadCnt() {
      return Math.min(this.limitChildren - this.totalMemberChildCnt + this.memberChildDetails.youjiCHeadCnt, this.limitChildren)
    },
    maxYoujiDHeadCnt() {
      return Math.min(this.limitChildren - this.totalMemberChildCnt + this.memberChildDetails.youjiDHeadCnt, this.limitChildren)
    },
    totalMemberChildCnt() {
      return Object.values(this.memberChildDetails).reduce((a, b) => a + b, 0);
    },
    totalChildMemberCnt() {
      return `${this.totalMemberChildCnt}人`;
    }
  },
  watch: {
    totalChildMemberCnt() {
      this.$emit('changeChildrenQuantity', this.memberChildDetails)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
